import { render } from "./TurntableDynamic.vue?vue&type=template&id=455e4fa5"
import script from "./TurntableDynamic.vue?vue&type=script&lang=js"
export * from "./TurntableDynamic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__